import { ApolloLink } from '@apollo/client/core';
const omitTypename = (key, value) => {
    return key === '__typename' ? undefined : value;
};
export class AuthorizationHeadersLink extends ApolloLink {
    constructor() {
        super();
        this.headers = {
            'content-type': 'application/json',
            'process.env.HEADER_KEY_ADMIN_USER': 'process.env.HEADER_ADMIN_USERNAME',
        };
    }
    request(operation, forward) {
        operation.setContext({ headers: this.headers });
        if (operation.variables) {
            operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
        }
        return forward(operation);
    }
    setAuthorization(idToken, accessToken) {
        if (idToken) {
            const Authorization = `Bearer ${idToken}`;
            Object.assign(this.headers, { Authorization });
        }
        if (accessToken) {
            const header = { 'X-Access-Token': accessToken };
            Object.assign(this.headers, header);
        }
    }
    isAuthorized() {
        return Boolean(this.headers['Authorization'] || this.headers['X-Access-Token']);
    }
}
